// Tracker state that more than one module reads AND writes: the page-view
// clock is reset by `index.ts`, shifted by the unload/visibility handlers in
// `observers.ts`, and read by `events.ts`. An exported `let` is a read-only
// live binding for importers, so the shared fields live on one mutable object
// instead. Module-private state stays a plain `let` in its owning module.
export const trackerState = {
  initialized: false,
  visitNumber: 0,
  initTs: 0,
  checkoutOpenTs: 0,
  formStartTs: 0,
  engagedMs: 0,
  lastActivityTs: 0,
  maxScrollPct: 0,
  sectionViewCount: 0,
  pageEngagedFired: false,
  engaged30Fired: false,
};

// Everything a single page view accumulates. Called on init and again on every
// client-routed page view, so the next page starts from zero.
export function resetPageMetrics(now: number): void {
  trackerState.initTs = now;
  trackerState.lastActivityTs = now;
  trackerState.engagedMs = 0;
  trackerState.sectionViewCount = 0;
  trackerState.pageEngagedFired = false;
  trackerState.engaged30Fired = false;
  trackerState.maxScrollPct = 0;
}
